import React, {useEffect, useRef, useState} from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {Card, CardContent} from '@mui/material';
import {COLORS} from '@/utils/constants';
import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';

interface Props {
	final: any[];
}

const QUESTIONS = [
	'question49',
	'question54',
	'question59',
	'question64',
	'question69',
	'question74',
	'question79',
	'question84',
	'question89',
	'question94',
	'question99',
	'question104',
];

const PieEntrepreneursObtainedFunds = ({final}: Props) => {
	const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
	const [options, setOptions] = useState<Highcharts.Options>();

	const calculateSubmissions = () => {
		const valid = final.filter((s) =>
			QUESTIONS.some((q) => ['Item 1', 'Item 2', 'Item 3'].includes(s[q]))
		);

		let yes = 0;
		let pending = 0;
		let no = 0;

		valid.forEach((submission) => {
			const hasYes     = QUESTIONS.some((q) => submission[q] === 'Item 1');
			const hasPending = QUESTIONS.some((q) => submission[q] === 'Item 2');

			if (hasYes)          yes++;
			else if (hasPending) pending++;
			else                 no++;
		});

		const data = [
			{name: 'Yes', y: yes, color: COLORS.green},
			{name: 'Pending', y: pending, color: COLORS.orange},
			{name: 'No', y: no, color: COLORS.gray},
		];

		const dashboardOptions: any = getDefaultPieFormatting('% of entrepreneurs who obtained the funds', data);
		setOptions(dashboardOptions);
	};

	useEffect(() => {
		calculateSubmissions();
	}, [final]);

	return (
		<Card className='chart-container'>
			<CardContent>
				{options && (
					<HighchartsReact
						highcharts={Highcharts}
						options={options}
						ref={chartComponentRef}
					/>
				)}
			</CardContent>
		</Card>
	);
};

export default PieEntrepreneursObtainedFunds;
